import { defineActions } from './defineActions'

/**
 * Paperwork. Action names start with Paperwork. The Paperwork components are shared between the
 * IME, Supplementary and MR modules, so the names carry no module prefix: the module comes from
 * the page's subject. The footer Save of the step is Ime.Paperwork.Save (ime-page.ts).
 *
 * Not tracked on purpose: file uploads, file deletes and share-link edits in the Paperwork fields
 * (they are only staged and become permanent with the footer Save), opening the Smokeball picker,
 * the Doc QA result or the Pre-Check (reads only), Doc QA Print and View (reads), and Copy
 * Summary (clipboard only).
 */
export const paperworkActions = defineActions({
  'Paperwork.SendCmReminder': {
    label: 'Send CM reminders',
    area: 'Paperwork',
    description: 'Paperwork reminder email to the booking CM.',
  },
  'Paperwork.SyncUhg': {
    label: 'Sync UHG Paperwork',
    area: 'Paperwork',
  },
  'Paperwork.ResendReadinessNotice': {
    label: 'Resend LOI readiness notice to Staff PIC',
    area: 'Paperwork',
  },
  'Paperwork.ResendICareRequirementToStaff': {
    label: 'Resend iCare requirement to Staff PIC',
    area: 'Paperwork',
  },
  'Paperwork.ResendICareRequirementToSpecialist': {
    label: 'Resend iCare requirement to Specialist',
    area: 'Paperwork',
  },
  'Paperwork.ResendToSpecialist': {
    label: 'Resend paperwork to Specialist',
    area: 'Paperwork',
  },
  'Paperwork.MergeDocuments': {
    label: 'Merge Case Documents',
    area: 'Paperwork',
    description: 'Merges the Other Documents into one PDF.',
  },
  'Paperwork.ImportSmokeBallDocuments': {
    label: 'Import from Smokeball',
    area: 'Paperwork',
    description:
      'Copies the picked Smokeball documents; the attachments are added by the next Save.',
  },
  'Paperwork.DocQa.Extract': {
    label: 'Extract Doc QA',
    area: 'Paperwork',
    description: 'Runs the LOI QA check and the LOI question extraction.',
  },
  'Paperwork.LoiQuestions.Confirm': {
    label: 'Confirm & publish LOI questions',
    area: 'Paperwork',
  },
  'Paperwork.LoiQuestions.Reject': {
    label: 'Reject AI-extracted LOI questions',
    area: 'Paperwork',
  },
  'Paperwork.LoiQuestions.Delete': {
    label: 'Delete Extracted Questions',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.UploadFile': {
    label: 'Upload Pre-Check file',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.DeleteFile': {
    label: 'Delete Pre-Check file',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.CopyFromPaperwork': {
    label: 'Copy file to Pre-Check',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.CopyAllFromPaperwork': {
    label: 'Copy all files to Pre-Check',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.Run': {
    label: 'Run Pre-Check',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.Rerun': {
    label: 'Run Pre-Check again',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.MergeToPaperwork': {
    label: 'Merge Pre-Check documents into Case Documents',
    area: 'Paperwork',
  },
  'Paperwork.PreCheck.Confirm': {
    label: 'I have checked this claim',
    area: 'Paperwork',
    description: 'Confirms the Pre-Check result.',
  },
  'Paperwork.PreCheck.Adjudicate': {
    label: 'Save Pre-Check decision',
    area: 'Paperwork',
    description: 'A decision on one Pre-Check checklist line.',
  },
})
